module.exports = __webpack_public_path__ + "static/media/bg6.1386aafc.jpg";